'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

import {
  FALLBACK_SELL_TO_COUNTRY,
  useSellToCountry,
} from '@/queries/SellToCountry';

export interface GeoProviderProps {
  readonly countryCode: string;
}

interface GeoContext {
  countryData:
    | {
        currency: string | null;
        countryCode: string | null;
        eu: boolean | null;
      }
    | null
    | undefined;
  isGeoReady: boolean;
}

const Context = createContext<GeoContext | null>(null);

export const useGeoContext = () => {
  const ctx = useContext(Context);
  if (!ctx) {
    throw new Error('Did you forget to include GeoProvider in your tree?');
  }
  return ctx;
};

const GeoProvider = ({
  children,
  countryCode,
}: PropsWithChildren<GeoProviderProps>) => {
  const { data, isLoading, isSuccess } = useSellToCountry(countryCode);
  const countryData = isSuccess
    ? data
    : FALLBACK_SELL_TO_COUNTRY.content!.countries![0]!;

  return (
    <Context.Provider value={{ countryData, isGeoReady: !isLoading }}>
      {children}
    </Context.Provider>
  );
};

export default GeoProvider;
